import React from 'react'
import './styles.scss'

/**
 *
 * @param {object} props
 * @param {boolean} props.isOpen
 * @param {React.Component} [props.header]
 * @param {string} [props.className]
 * @param {string} [props.id]
 */

const Dropdown = (props) => {
  const {
    isOpen,
    header,
    children,
    className,
    id
  } = props


  return (isOpen &&
    <div
      className={`container-drop ${className}`}
    >
      {header}
      <div className='dropdown-wrapper' id={id}>
        {children}
      </div>
    </div>
  )
}

export default Dropdown